/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Stage_DiscoveryInputs */

const en_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discovery & Topology`)
};

const ar_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاستكشاف والطوبولوجيا`)
};

const bn_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিসকভারি ও টপোলজি`)
};

const de_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdeckung und Topologie`)
};

const es_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubrimiento y topología`)
};

const fr_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découverte et topologie`)
};

const pt_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descoberta e Topologia`)
};

const zh_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现与拓扑`)
};

const tr_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keşif ve Topoloji`)
};

const ru_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение и топология`)
};

const pl_svc_stage_discovery = /** @type {(inputs: Svc_Stage_DiscoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykrywanie i topologia`)
};

/**
* | output |
* | --- |
* | "Discovery & Topology" |
*
* @param {Svc_Stage_DiscoveryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_stage_discovery = /** @type {((inputs?: Svc_Stage_DiscoveryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Stage_DiscoveryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_stage_discovery(inputs)
	if (locale === "bn") return bn_svc_stage_discovery(inputs)
	if (locale === "de") return de_svc_stage_discovery(inputs)
	if (locale === "es") return es_svc_stage_discovery(inputs)
	if (locale === "fr") return fr_svc_stage_discovery(inputs)
	if (locale === "pt") return pt_svc_stage_discovery(inputs)
	if (locale === "zh") return zh_svc_stage_discovery(inputs)
	if (locale === "tr") return tr_svc_stage_discovery(inputs)
	if (locale === "ru") return ru_svc_stage_discovery(inputs)
	if (locale === "pl") return pl_svc_stage_discovery(inputs)
	return en_svc_stage_discovery(inputs)
});